import type { ReactNode } from 'react';
import { memo } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router';

import AppShell from './components/AppShell';
import ErrorPage from './pages/error';
import Main from './pages/Main';
import Playlist from './pages/Playlist';
import Vod from './pages/VOD';
import { UefatvOptionsProvider } from './store';
import type { UefatvOptions } from './store/types';

import { competitionUrl } from '@utilities/WindowContext';

const App = ({ options, placeholder }: { options: UefatvOptions; placeholder?: ReactNode }) => (
  <UefatvOptionsProvider options={options}>
    <AppShell placeholder={placeholder}>
      <BrowserRouter basename={`${competitionUrl}/uefatv`}>
        <Routes>
          <Route path='/' element={<Main placeholder={placeholder} />} />
          <Route path='error/' element={<ErrorPage />} />
          <Route path='vod/:videoId' element={<Vod />} />
          <Route path='playlist/:playlistId' element={<Playlist />} />
        </Routes>
      </BrowserRouter>
    </AppShell>
  </UefatvOptionsProvider>
);

export default memo(App);
